<template>
  <div class="bgfff pop-content b_r_10 plr20 pos">
      <van-icon
        name="cross"
        class="pop-close"
        size="30"
        @click="show = false"
      />
      <div class="txt_center pt20 mb20">重置密码</div>
      <div class="flex flex_items mb10 pb10 bor_b">
        <div style="width: 80px;">旧密码</div>
        <input
          type="password"
          v-model="password"
          style="width: 180px;height: 40px;"
          placeholder="请输入密码"
        />
      </div>
      <div class="flex flex_items" style="margin-bottom: 50px;">
        <div style="width: 80px;">新密码</div>
        <input
          type="password"
          v-model="repassword"
          style="width: 180px;height: 40px;"
          placeholder="请输入密码"
        />
      </div>
      <div class="pop-btn main_bg b_r_10" @click="reN">确认重置</div>
    </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      repassword: "",
      password: "",
    };
  },
  props:{
    show:false,
  },
  methods: {
			re() {
				this.$emit('closeFn')
			},
			// 重置
			reN() {
				// if (this.password == '' || this.password != this.repassword) {
				// 	this.Toast('密码有误')
				// 	return
				// }
				Dialog.confirm({
						title: '重置',
						message: '确定重置此密码？',
					})
					.then(() => {
						this.api.changePassword({old_password:this.password,new_password:this.repassword}).then(res => {
							this.Toast('重置成功')
							this.$emit('closeFn');
              setTimeout(() => {
                this.$emit('successFn')
              }, 1000);
						})
					})
					.catch(() => {
						// on cancel
					});
			}
		}
};
</script>
<style scoped="scoped">
	.bg_blue{
		background-color: #C2E1FF;
		color: #3399FF;
	}
	.y_bg{
		background-color: #FFF0D1;
		color: #FF9966;
	}
	.gr_bg{
		color: #00D8CC;
		background-color: #D1F0E1;
	}
	.pop-content {
		width: 300px;
		height: 270px;
		box-sizing: border-box;
	}
	
	.pop-btn {
		width: 250px;
		margin: 0 auto;
		text-align: center;
		color: #fff;
		height: 40px;
		line-height: 40px;
	}
	
	.pop-close {
		position: absolute;
		top: 10px;
		right: 10px;
	}
</style>
